export default __webpack_public_path__ + "static/media/icon_arrow_up_small.df357d76.svg";